@if (selectionTags(); as selectionTags) { @if (selectionTags.length) {
<div libFlexRow [libFlexRowGap]="'8px'">
	@for (selectionTag of selectionTags; track selectionTag.title) {
	<div libFlexColumn>
		<lib-tag
			class="w-selection-tag"
			(click)="selectionTag.click()"
			[tagType]="selectionTag.isActive ? 'primary' : basicTagType()"
			>{{ selectionTag.title }}</lib-tag
		>
	</div>
	}
</div>
} }
